'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getEditorState = exports.getEditorState = function getEditorState(state) {
  return state.get('editorState');
};
var getEditorId = exports.getEditorId = function getEditorId(state) {
  return state.get('editorId');
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/store/reducers/editorStoreSelector.js
// module id = 691
// module chunks = 0